import { render } from "./MentorList.vue?vue&type=template&id=9494f3e2"
import script from "./MentorList.vue?vue&type=script&lang=js"
export * from "./MentorList.vue?vue&type=script&lang=js"

import exportComponent from "/home/parallels/Web/Repos/mentee-mentor/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__